import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useGetPostsList } from "@/api/useGetPostsApi";
import { useGetSiteId } from "@/api/useGetSiteApi";

const AUTOPLAY_DELAY = 5000;

const useNewsSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const { siteId } = useGetSiteId();
  const { data, isLoading } = useGetPostsList({ page: 1, count: 5, siteId });

  const posts = useMemo(
    () => data?.data.list.filter((item) => !item.isHidden) ?? [],
    [data],
  );

  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    if (posts.length <= 1) return;
    timerRef.current = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % posts.length);
    }, AUTOPLAY_DELAY);
  }, [posts.length]);

  const goTo = useCallback((index: number) => {
    setActiveSlide(index);
  }, []);

  useEffect(() => {
    if (posts.length === 0) return;
    startTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [startTimer]);

  return { activeSlide, posts, isLoading, goTo };
};

export default useNewsSection;
